export const UPDATE_WEALTH_SOURCE_DATA = 'UPDATE_WEALTH_SOURCE_DATA'
export const UPDATE_WEALTH_SOURCE_DATA_COMPLETE = 'UPDATE_WEALTH_SOURCE_DATA_COMPLETE'
export const UPDATE_MY_WEALTH_PLUS_PAYLOAD = 'UPDATE_MY_WEALTH_PLUS_PAYLOAD'
export const MY_WEALTH_PLUS_SALE_PERMISSION_CHECK = 'MY_WEALTH_PLUS_SALE_PERMISSION_CHECK'
export const MY_WEALTH_PLUS_FUND_LISTS = 'MY_WEALTH_PLUS_FUND_LISTS'
export const INIT_CUSTOMER_PROFILE = 'INIT_CUSTOMER_PROFILE'

export const updateWealthSourceData = (info) => ({
  type: UPDATE_WEALTH_SOURCE_DATA,
  payload: info,
})

export const updateWealthSourceDataComplete = () => ({
  type: UPDATE_WEALTH_SOURCE_DATA_COMPLETE,
})

export const updateMyWealthPayload = (mwPlusPayload) => ({
  type: UPDATE_MY_WEALTH_PLUS_PAYLOAD,
  payload: mwPlusPayload,
})

export const validateMyWealthSalePermission = (product) => ({
  type: MY_WEALTH_PLUS_SALE_PERMISSION_CHECK,
  payload: product,
})

export const getMyWealthProfile = (payload) => ({
  type: INIT_CUSTOMER_PROFILE,
  payload,
})
